import { SanityComparisonTable } from '#/lib/sanity/queries/comparisonTableSection';

import { RichText } from '../RichText';
import { Tooltip } from '../Tooltip';
import { CellIcon } from './CellIcon';

export const DesktopTable = (props: SanityComparisonTable) => {
  return (
    <div className="overflow-x-auto hidden md:block">
      <table className="text-charcoal table-fixed w-full border-collapse">
        <thead>
          <tr className="border-b border-grayscale-03">
            <th className="w-[40%]" />
            {props.headers.map((header: string, index: number) => (
              <th
                className="text-17 l:text-22 font-[440] leading-105 text-left py-25 "
                key={index}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.rows.map((row) => (
            <tr key={row._key} className="border-b border-grayscale-03">
              <td className="text-16 font-[440] leading-105 py-25 pr-25">
                <div className="flex items-center gap-10">
                  {row.featureLabel}

                  <Tooltip position="right">
                    <RichText
                      value={row.featureContent}
                      normalTextSizeClassName="text-12 font-[400] leading-120"
                    />
                  </Tooltip>
                </div>
              </td>
              {row.cells.map((cell) => (
                <td key={cell._key} className="py-25">
                  <CellIcon icon={cell.icon} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
